export const SKELETON_CATEGORY_IDS = Array.from(
  { length: 10 },
  (_, index) => index,
);

export const SKELETON_GAME_IDS = SKELETON_CATEGORY_IDS;
